function t(n, e) {
  return (n.length + e) % n.length;
}
export {
  t as toValidIndex
};
//# sourceMappingURL=index6.js.map
